import { useQuery } from '@tanstack/react-query';
import { supabasePublic } from '@/integrations/supabase/publicClient';
import { TableAvailability } from '@/types/table';

export function availabilitiesQueryKey(establishmentId: string | null) {
  return ['availabilities', establishmentId] as const;
}

export function useAvailabilitiesQuery(establishmentId: string | null) {
  return useQuery({
    queryKey: availabilitiesQueryKey(establishmentId),
    queryFn: async (): Promise<TableAvailability[]> => {
      let query = supabasePublic.from('table_availability').select('*');
      if (establishmentId) query = query.eq('establishment_id', establishmentId);

      const { data, error } = await query;
      if (error) throw error;

      return (data || []).map((a: any) => ({
        id: a.id,
        tableId: a.table_id,
        date: new Date(a.date),
        isAvailable: a.is_available,
        reason: a.reason || undefined,
      }));
    },
    enabled: Boolean(establishmentId),
    staleTime: 1000 * 60 * 2,
  });
}
